import * as catalogos from './catalogos/zh2';
export const locale = {
  lang: 'zh2',
  data: {
    'CERTIFICARV3': {
      'GUAR_CAMB':'正在保存更改...',
      'CATALOGOS': {
        'SECCIONES': catalogos.secciones,
        'PREGUNTAS': catalogos.preguntas,
        'ABIERTAS': catalogos.abiertas,
        'PREG_ESPECI': catalogos.preguntasEspeciales,
      },
      'TITULO_TAB_PREG':'问题',
      'TITULO_TAB_TRAD':'翻译',
      'TITULO_TAB_PREV':'预览',
      'TAB_PREGUNTAS':{
        'CLA':'钥匙:',
        'BTN_CONFIG_PLA':'模板配置',
        'SLI_VER_US_EMPRE':'以业务用户身份查看',
        'ETI_INSTNES':'您可以按照以下步骤加载模板中包含的问题列表:',
        'ETI_INST1':'下载模板',
        'ETI_INST2':'根据格式填写问题模板',
        'ETI_INST3':'使用问题加载模板',
        'ETI_INST_NOT':'注意:您可以以一般方式或在每个可用部分内上传问题列表',
        'ETI_SECCI_NOT_GRU':'此部分没有组',
        'INST_AGRE_GRUP':'使用以下按钮添加一组问题',
        'BTN_AGRE_GRUP':'添加群组',
        'INST2_AGRE_GRUP':'您以后可以向该组添加问题',
        'ETI_DETEC_CAMB_PLAN':'在原始模板中检测到更改',
        'BTN_GUAR_CAMB':'保存更改',
        'BTN_GUAR_CAMB_NEW_PLAN':'另存为新模板',
        'MAT_DESC_PLAN':'下载模板',
        'ETI_LIS_GRUP':'组列表',
        'MAT_CHIP_PRE_EXTR_SI':'其他可用问题:',
        'MAT_CHIP_PRE_EXTR_NO':'您不能再添加其他问题',
        'MAT_CHIP_PRE_EXTR_ILIM':'无限的额外问题',
        'ETI_INST_COLO_CUR':'将光标置于任何组上以查看可用的操作',
        'MAT_EDIT_NOMB_SECC':'编辑组的名称',
        'MAT_DELET_SECC':'删除该组',
        'MAT_AGRE_SECC_ARRI':'在上方添加群组',
        'ETI_SECC_SIN_PREG':'这个小组没有问题',
        'ETI_SECC_INST_COLO_CUR':'将光标放在问题上以查看可用的操作',
        'ETI_PREG_OPCIO_EDITA':'可选的可编辑问题',
        'ETI_PREG_OPCIO_NO_EDITA':'可选的不可编辑的问题',
        'ETI_PREG_OPCIO_OBLI_EDITA':'必填项',
        'ETI_PREG_OPCIO_OBLI_NO_EDITA':'强制性不可编辑问题',
        'ETI_PREG_RESP_OBLI_NO_EDITA':'必填问题答案',
        'MAT_FALT_OPC_RESP':'缺少响应选项',
        'ETI_FALT_OPC_RESP':'问题缺少答案选项',
        'MAT_NO_GUAR_CATA':'尚未保存在目录中',
        'ETI_PREG_NO_GUAR_CATA':'问题尚未保存在目录中',
        'MAT_CHIP_TIP':'类型',
        'MAT_TOOL_DETA_PREG':'问题详细信息',
        'BTN_EDIT_PREG':'查看详细信息',
        'MAT_TOOL_MOVE_PREG':'提出这个问题',
        'BTN_EDIT_ES_PREG':'编辑此问题',
        'BTN_DELE_ES_PREG':'删除此问题',
        'MAT_TOOL_AGRE_PREG_ARRI':'在上方添加问题',
        'MAT_TOOL_AGRE_PREG_ABAJ':'在下方添加问题',
        'MAT_LABE_SELE_VERSI_PREG':'选择问题的版本',
        'MAT_LABE_TEX_PREG':'问题文本',
        'MAT_LABE_TEX_PREG_KEY':'特殊问题键',
        'ETI_CUE_SIG_ACC_PREG':'依靠这个问题的以下动作',
        'MAT_CARD_MAES':'主目录',
        'ETI_DETEC_CAMB_TEX_PREG':'在问题文本中检测到更改',
        'MAT_TOOL_YET_NO_GUA_CAT':'尚未保存在目录中',
        'ETI_ESTA_PREG_NO_GUAR_CATA':'此问题未保存在目录中',
        'ETI_GUAR_PREG':'保存问题',
        'ETI_GUAR_CAMB':'保存更改',
        'MAT_SLIDE_PREG_EDIT':'可编辑的问题',
        'MAT_SLIDE_PREG_DELET':'可移动问题',
        'MAT_SLIDE_PREG_REQUI':'必填项',
        'ETI_AGRE_PREG':'添加问题',
        'ETI_GRUP_PREG ':'问题组',
        'ETI_SECC_ESP ':'特节',
        'ETI_KEY_NO_EMPL':'未使用特殊节键',
        'ETI_FALT_KEY_SEC_ESP':'*缺少特殊部分键',
        'ETI_CLA_GRU_LIS':'关键词:',
        'DIALOG_MODAL':{
          'ETI_MOVE_PREG':'提出问题',
          'ETI_INTS_SELEC_SECC_MOVE':'选择您要将问题移至的组',
          'ETI_NOT_PREG_MOVE1':'注意:',
          'ETI_NOT_PREG_MOVE2':'该问题将移至所选组的末尾',
          'BTN_CANCELAR':'取消',
          'ETI_CONFI_PLAN':'模板配置',
          'ETI_DATOS_PLAN':'模板数据:',
          'ETI_NOMB':'名称:',
          'ETI_SECC':'团体',
          'ETI_PREG':'问题:',
          'ETI_NOT_CONF_CONT_SECC':'注意：这些控件的配置适用于以业务类型用户在显示模式下显示的模板中的所有组和问题',
          'ETI_PERMI_SECC':'组权限',
          'ETI_AGRE_SECC_NEW':'添加新组',
          'ETI_MOVE_SECC':'移动组',
          'ETI_EDIT_TITU':'编辑标题',
          'ETI_DELET_SECC':'删除群组',
          'ETI_NOMB_OBL_GRUP_NEW':'新组中的必填名称',
          'ETI_ENABLE_SEC_ESP': '启用特殊问题/部分',
          'ETI_PERMIS_PREG':'每个组的问题权限:',
          'ETI_AGRE_PREG_NEW':'添加新问题',
          'ETI_AGRE_PREG_CATAL':'添加目录问题',
          'ETI_MOVE_PREGS':'提出问题',
          'ETI_EDIT_PREG':'编辑问题',
          'ETI_DELET_PREG':'删除问题',
          'ETI_REQUIRED':'是否需要答案？',
          'ETI_PREG_NEW_MAX':'新的最大问题数',
          'ETI_PREG_NEW_MAX_4ALL':'练习次数 4All',
          'ETI_MAX_PREG_NEW':'最大新问题',
          'ETI_ENABLE_AUDIOS': '启用音轨',
          'ETI_DEMOGRAF':'人口统计',
          'ETI_ABIER':'打开',
          'ETI_PRAC4ALL':'Practices 4All',
          'ETI_ADICIO':'其他',
          'BTN_SAL':'退出',
          'ETI_INST_AGRE_PREG_CAT':'添加目录问题',
          'ETI_BUSC_SELECC_PREG_PLAN':'在此屏幕中,您可以搜索并选择要添加到模板的问题',
          'TITULO_TAB_LIS_PREG':'问题清单',
          'TITULO_TAB_BUSC_PREG':'搜索问题',
          'TITULO_TAB_PREG_SELEC':'选择的问题',
          'PASO_1':'步骤1',
          'PASO_2':'第2步',
          'ETI_VER_LIS_PREG_SELEC_3_PEST':'您可以在此窗口的第三个标签中看到所选问题的列表',
          'ETI_SELEC_PREG_LIS_CAT':'从目录中的列表中选择问题',
          'ETI_SELEC_PREG':'选择问题',
          'ETI_YA_SELEC_NUM_MAX_PREG':'您已经选择了模板中允许的最大额外问题数',
          'ETI_PREG_MS_UNA_VERS':'此问题有多个版本,请选择您要查看的版本',
          'ETI_SELEC_VERS':'选择版本',
          'ETI_PREG_SELECCIONDA':'选择的问题:',
          'ETI_AGRE_PREG':'添加问题',
          'ETI_OK_AGRE_PREG_LIST':'<b>问题已添加到问题列表中</ b>,您可以选择并添加更多问题以添加到模板中',
          'ETI_OK_AGRE_PREG_LIST2':'您也可以在此窗口的第三个标签中看到所选问题的列表',
          'ETI_ESCR_TEXT_BUSC':'输入您要搜索的问题的文本',
          'ETI_BUSC_PREG_COINC':'搜索匹配的问题',
          'ETI_NO_ENCO_PREG':'对于输入的文本未发现任何问题,请尝试其他文本',
          'ETI_RESUL_BUSC':'搜索结果',
          'BTN_ELEG':'选择',
          'ETI_REGRE_RESUL':'返回结果',
          'ETI_PREG_SELECC_MOMEN':'到目前为止选择的问题列表',
          'MAT_TOOL_ELEG_VERSI':'选择其他版本',
          'MAT_TOOL_ELI_VERSI':'删除版本',
          'BTN_REGRES':'返回',
          'BTN_ELIG_VERSI':'选择版本',
          'MAT_TOOL_QUITA_LIS':'从列表中删除',

          'BY_TEXT': '按问题文本',
          'BY_KEYWORDS': '按关键字',
          'QUESTION_TEXT': '问题文本',
          'QUESTION_KEYWORDS': '关键词',
          'QUESTION_HINT': '关键字必须以字符 <b> # </b> 开头并用逗号分隔'
        },
        'DETALLE':{
          'ETI_DETALL_PREG':'问题详细信息',
          'ETI_LAB_TEX_PREG':'问题文本',
          'PLACE_HOL_TEX_PREG':'问题文本',
          'MAT_TOOL_EDIT_PREG':'编辑此问题',
          'MAT_CARD_OPC_RESP':'响应选项',
          'MAT_TOOL_EDIT_RESP':'编辑此答案',
          'MAT_TOOL_DELET_RESP':'删除此答案',
          'ETI_AGRE_OPCI_RESP':'添加答案选项',
          'ETI_SELEC_VERSI_PREG':'选择问题的版本',
          'ETI_CUENT_SIG_ACC_PREG':'依靠这个问题的以下动作',
          'ETI_DETEC_CAMB_TEXMAES':'主目录',
          'ETI_CATA_MAES':'主目录',
          'ETI_DETEC_CAMB_TEX_PREG':'在问题文本中检测到更改',
          'ETI_DETEC_CAMB_TEX_RESP':'检测到响应选项的更改',
          'ETI_PREG_NO_GUAR_CATA':'此问题未保存在目录中',
          'ETI_GUAR_PREG':'保存问题',
          'ETI_GUAR_CAMB':'保存更改',
          'ETI_BORR_PREGUN':'删除问题',
          'ETI_DELET_PREG':'删除问题',
          'MAT_CARD_PLAN':'模板',
          'MAT_SLIDE_PREG_EDIT':'可编辑的问题',
          'MAT_SLIDE_PREG_DELET':'可移动问题',
          'MAT_SLIDE_PREG_REQUI':'必填项',
          'BTN_REGRES':'返回',
          'ETI_NEW_PREG':'新问题',
          'ETI_ESCR_TEXT_SELEC_TIP_PRE':'输入文字并选择新问题的答案类型',
          'ETI_ESCR_TEXT_AGRE_OPCI_RESP':'编写文本并为新问题添加答案选项',
          'ETI_TIP_PREG':'问题类型',
          'ETI_TIP_RESP':'响应类型',
          'ETI_TIP_FORM':'问题格式',
          'ETI_PREG_ESP_FLD': '特殊问题键',
          'ETI_PREG_ESP_HNT': '输入特殊问题的密钥',
          'BTN_CANCELAR':'取消',
          'BTN_CONTINU':'继续',
          'ETI_NEW_PRAC_4ALL':'New 4All练习',
          'ETI_INST_NAME_DESC_4ALL':'输入新的4All练习的名称和描述',
          'ETI_LABE_NAME':'实践名称',
          'ETI_LABE_DESC':'做法说明',
          'ETI_CLAVE_DEMOGR':'从字符开始，写一个或多个识别问题的关键字',
          'ETI_CLAVE_DEMOGR1':'并以逗号分隔',
          'ETI_CLAVE_DEMOGR2': '注意：仅当关闭此窗口时将此问题保存到目录中时，才会存储关键字',
          'ETI_PALA_CLAVE_DEMOGR':'关键字',
          'ETI_SELE_TIPO_DEMOGR':'选择与新问题相对应的人口统计类型',

          'MAT_TOOL_CONFIG_RESP':'配置这个答案',
          'MAT_SLIDE_RESP_EDIT':'可编辑答案',
          'MAT_SLIDE_RESP_DELET':'可移动答案',
          'MAT_SLIDE_RESP_TIPO_OTRO':'输入“其他”',
          'MAT_TOOL_NEWVERS_PREG':'另存为新版本',
          'NOTA_PREG_MOD': '注意：此问题的文本已被修改，如果您愿意，可以将其另存为新版本',
          'RESPUESTA_TIPO_OTRO':' - 回答类型“其他”',

          'TIPO_DEMOGRAFICO':'人口统计类型',
          'SIN_TIPO_DEMOGRAFICO':'没有为此问题选择人口统计类型'

          //     {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LABE_DESC'|translate}}
        },
        'MSJ_MODALES':{
          'TITU_MOD_GUA_CAM_TEMP':'新模板',
          'TEXT_MOD_GUA_CAM_TEMP':'输入新模板的名称',
          'BTN_CAN_MOD_GUA_CAM_TEMP':'取消',
          'BTN_AGRE_MOD_GUA_CAM_TEMP':'添加',
          'RETUR_MOD_GUA_CAM_TEMP':'您尚未输入名称的文字',
          'SUCC_TEXT_MOD_GUA_PLAN':'新模板已正确保存',
          'TITU_MOD_GUA_CAM_TEMP2':'您要保存对原始模板所做的更改吗？ 警告:下次使用此模板分配产品时,将包括到目前为止所做的所有更改',
          'BTN_CONTI_MOD_GUA_CAM_TEMP':'继续',
          'SUCC_TEXT_MOD_GUA_PLAN_ORG':'对原始模板的更改已正确保存',
          'MENS_1':'您想在此部分中添加什么样的问题？',
          'MENS_2':'您有两个选择',
          'BTN_NEW':'New',
          'BTN_D_CATA':'来自目录',
          'TITU_MOD_CARG_LIS_COLAB_P1':'此文件包含',
          'TITU_MOD_CARG_LIS_COLAB_P2':'部分总计',
          'TITU_MOD_CARG_LIS_COLAB_P3':'问题。警告:如果继续加载此文件,将替换当前存在的问题和组',
          'TITU_TEX_MOD_CARG_LIS_COLAB':'您有两个选择',
          'BTN_AGRE_PREGU':'添加问题',
          'BTN_CANC_PREGU':'放弃问题',
          'TEXT_MOD_SUCCE_CARG_LIS_COLAB':'问题已正确添加',
          'TEXT_MOD_NOT_CARG_LIS_COLAB':'问题已被放弃',
          'TEXT_MOD_ERRO_CARG_LIS_COLAB':'所选文件有错误,无法加载。再次检查所有行的排列顺序是否正确,然后重试',
          'BTN_OK':'确定',
          'TITU_MOD_NEW_SECC':'新栏目',
          'TEXT_MOD_NEW_SECC':'输入新部分的名称',
          'TEXT_SUCC_PREG_AGRE':'问题已正确添加',
          'TITU_MOD_EDI_SECC':'修改节名称',
          'TEXT_SUCC_MODIF_SECC':'部分名称已正确更改',
          'TEXT_SUCC_MODIF_GRU':'组名已修改',
          'TITU_MOD_DELE_SECC1':'确定要删除此部分吗？',
          'BTN_SI':'是',
          'BTN_NO':'否',
          'TITU_MOD_DELE_SECC2':'本节包含一个或多个问题,您想对这些问题做什么？',
          'BTN_DELE_PRE':'删除问题',
          'BTN_CAN_TRAN':'将它们转移到上一部分',
          'TEX_SUCC_DELE_PREG':'该部分已正确删除',
          'TITU_AGRE_NEW_PREG':'新问题',
          'TEXT_AGRE_NEW_PREG':'输入新问题的文本',
          'TITU_EDIT_PREG_MOD_PREG':'修改问题',
          'TITU_EDIT_PREG_MOD_PRACT':'修改惯例',
          'TITU_EDIT_PREG_MOD_DESCRI':'修改描述',
          'TEXT_MOD_PREG_SUCC':'问题已正确修改',
          'TITU_2_OPCIO':'您有两个选择来保存此修改',
          'BTN_CONF_ACT':'更新问题',
          'BTN_CANC_NEW':'作为新问题',
          'BTN_CONF_ACT_VERSION':'更新这个版本',
          'BTN_CANC_NEW_VERSION':'作为新版本',
          'TEX_CONFIR_MSG1':'问题已正确修改',
          'TEX_CONFIR_MSG2':'实践已正确修改',
          'TEX_CONFIR_MSG3':'描述已正确修改',
          'TITU_DELE_PREG':'确定要删除此问题吗？',
          'TEXT_SUCC_PREG':'问题已正确删除',
          'TITU_MOD_DELE_SECC_TEMPLA':'确定要删除此部分吗？',
          'TITU_MOD_DELE_SECC_TEMPLA2':'本节包含一个或多个问题,您想对这些问题做什么？',
          'TEX_SUCC_GUAR_PREG_':'问题已正确保存',
          'TITU_MOD_DELE_PREG_MG':'确定要从目录中删除问题吗？警告:此操作无法撤消,并且该问题在当前包含该操作的模板中不再可用',
          'TEX_CONFIR_MSG4_DELE':'该问题已正确从目录中删除',
          'TEX_GUAR_TRADU_SUCC':'翻译已正确保存',
          'TEX_MOVE_PREG_SECC':'问题已移至另一部分',
          'TEX_SUCC__PRAC_4ALL':'实践已正确添加',
          'MOD_MOD_AGRE_PREG':'该问题已正确添加到列表中',
          'MOD_MOD__MODIF_VERSI_PREG':'问题的版本已正确更改',
          'MOD_MOD__QUIT_PREG_LIST':'问题的版本已正确更改',
          'TITU_NUE_OPC_RESP':'新答案选项',
          'TEXT_NUE_OPC_RESP':'输入新选项的文字',
          'TEXT_NO_TEXT_PREG':'您尚未输入问题的文字',
          'TEXT_AGRE_OPC_RESP':'已正确添加响应选项',
          'MOD_EDIT_RESP':'修改答案选项',
          'MOD_EDIT_MODIF_OPC_RESP':'答案选项已正确修改',
          'MOD_COMFIR_DELE_OPC_RESP':'确定要删除此答案选项吗？',
          'MOD_SUCC_DELE_OPC_RESP':'答案选项已被正确删除',
          'MOD_NO_CONT_SIN_HAB_AGRE_OPC_RESP':'在不为问题添加答案选项的情况下无法继续进行',
          'MOD_NO_CONT_SIN_HAB_ESCR_OPC_RESP':'如果没有先写下问题的文本,就不能继续进行',
          'MOD_NO_CONT_SIN_HAB_ELE_TIP_RESP':'如果没有选择问题类型,您将无法继续',
          'MOD_AGRE_PREG_DONDE_GUARDAR': '在添加新问题之前，是否要将其保存到目录中？ 还是您只想在本调查中使用它？',
          'MOD_AGRE_PREG_DONDE_GUARDAR_INFO': '通过将其保存到目录中，可以根据需要将其提供给其他调查。',
          'BOT_DONDE_GUARDAR_1': '保存到目录',
          'BOT_DONDE_GUARDAR_2': '仅将其保存到此调查',
          'MOD_SIN_TAGS': '您尚未为该问题输入至少一个关键字',
          'MOD_SIN_OPC_RESP': '您尚未为该问题输入至少两个答案选项',
          'MOD_SIN_TIPO_DEMO': '您尚未为此问题选择受众特征类型',
          'MOD_SIN_CLA_ESPE': '您尚未添加特殊问题的关键',
          'MOD_SIN_TIPO_RESP': '您必须选择问题的答案类型才能继续',
          'MOD_RESP_DELOK': '答案选项已成功删除',
          'MOD_RESP_DELCATOK': '该问题已成功从目录中删除',
          'MOD_RESP_ADDTAGOK': '关键字已正确添加到问题',
          'MOD_RESP_ADDTAGERR': '关键字不是以＃字符开头',
          'MOD_RESP_DELTAGOK': '关键字已从问题中正确删除',
          'MOD_SAVE_CAMBIOS_PREGCAT': '保存对此目录问题的更改时，所做的修改将另存为问题文本和答案选项的新版本（如果适用）。\n\n你想继续吗？',
          'MOD_SAVE_CAMB_PREGCAT': '你想在哪里存储对问题文本的修改？',
           'BTN_MOD_SAVE_CAMB_PREGCAT': '仅在本次调查中',
           'BTN_MOD_ACTUA_PREGCAT': '更新目录中的问题',
        }
      },
      'TAB_TRADUCCION':{
        'TEX_MOD_CARG':'正在加载',
        'TEXT_NO_ELEG_ADIC':'未选择其他语言',
        'ERR_MSG_TRADU':'翻译尚未完成',
        'TEX_IDIO_PRIN':'主要语言',
        'TEX_NAM_GRUP':'组名',
        'TEX_TRAD_NAM':'输入名称的翻译',
        'TEX_NO_TRAD_TEXT':'您尚未输入翻译文本',
        'TEX_TEX_PREG':'问题文本',
        'TEX_TEX_RESP':'回复文字',
        'TEX__TRA_PREG':'输入问题的翻译内容',
        'TEX__TRA_RESP':'输入答案的译文',
        'GUAR_TRA_NAM':'正在保存名称翻译,请稍候',
        'GUAR_TRA_PRE':'正在保存问题翻译,请稍候',
        'GUAR_TRA_RES':'正在保存答案选项的翻译,请稍候',
        'INGR_TEX_PRAC_4ALL':'练习',
        'INGR_TEX_TRADU_PRAC_4ALL':'输入练习翻译',
        'INGR_TEX_DESCR_4ALL':'说明',
        'INGR_TEX_TRADU_DESCR_4ALL':'输入描述的译文',
        'GUAR_TRADU_PRAC':'正在保存练习翻译,请稍候...',
        'GUAR_TRADU_DESCR':'正在保存描述翻译，请稍候...',

      },
      'TAB_PREVIEW':{
        'INST_SELECC_IDI':'选择一种语言以显示问题的翻译',
        'ETI_SIN_TRAD_PRE':'¡翻译文本丢失！',
      },
      'MODAL_AUDIO': {
        'TITULO': {
          'ADD': '添加音轨',
          'CHANGE': '替换音轨'
        },
        'SUBTITULO': '您可以通过以下选项之一将音轨与此问题相关联',
        'BOTONES': {
          'RESTART': '返回开始',
          'NEXT': '下一个',
          'BACK': '回去',
          'ACEPTAR': '接受',
          'CANCELAR': '取消'
        },
        'OPCIONES': {
          'GOOGLE': '生成自动旁白',
          'RECORD': '录制旁白',
          'ARCHIVO': '上传 mp3 文件',
        },
        'PASOS': {
          'GOOGLE': {
            'TITULO': '您可以编辑文本以生成自动旁白',
            'INPUT': '问题文本',
            'INPUT_TT': '写问题文本',
            'NOTA': '注意：修改此文本不会修改调查中的问题文本'
          },
          'RECORD': {
            'TITULO': '单击“录制”按钮开始从麦克风录制音频',
            'NOTA': '注意：您可能需要向浏览器授予使用麦克风的权限',
            'START': '开始录音',
            'STOP': '录制音频，点击按钮停止录制'
          },
          'ARCHIVO': {
            'INPUT': '单击此处或将音频文件拖动到此区域以加载它',
            'NOTA': '注意：仅支持 MP3 格式'
          },
          'PREVIEW': {
            'GENERANDO': '正在生成音频，请稍等',
            'TITULO': '您可以在下方收听加载的音频',
            'NOTA_1': '如果要将此音轨保存到问题中，请单击“确定”按钮',
            'NOTA_2': '如果要更改音频，请单击后退按钮',
            'NOTA_3': '如果要更改加载的音频类型，请单击“返回开始”按钮'
          }
        },
        'MODALES': {
          'DESCARTAR': '你确定要回到上一步吗？ \n\n 当前曲目将被丢弃',
          'ARCHIVO_MAL': '上传的文件不是音轨',
          'GUARDANDO': '将音轨保存到问题中，稍等片刻',
          'BORRAR': '您确定要删除与此问题相关的音轨吗？',
          'CONFIRMAR_BORRAR': '要确认，请在文本框中输入红色代码：\n\n',
          'BORRADO_OK': '问题的音轨已正确删除',
          'CODIGO_MAL': '输入的代码与红色标示的不匹配',
          'AGREGANDO_PREGUNTAS': '部分问题正在添加中，请稍等'
        },
        'PREVIOS': {
          'TITULO': '相关音轨',
          'SIN_AUDIO': '没有关联的音轨',
          'SIN_AUDIO_FORALL': '没有音轨',
          'ADD_AUDIO': '添加音轨',
          'CON_AUDIO': '这个问题有一个音轨',
          'PLAY': '播放音频',
          'CHANGE': '替换音频',
          'DELETE': '删除音频',
          'AUDIO_STATEMENT_1': '声明 1 的音轨',
          'AUDIO_STATEMENT_2': '声明 2 的音轨',
        }
      },
      'MODAL_SEC_ESP': {
        'TITULO': '特别版块',
        'SUBTITULO_1': '这组问题可以建立一个特殊的版块，这个组的问题只会显示给密码相同的合作者',
        'SUBTITULO_2': '注意：在合作者上传步骤中，必须至少有一个合作者与此特殊部分相关联',
        'TIPOS': {
          'NORMAL': '普通款',
          'ESPECIAL': '特别版块'
        },
        'CAMPO': {
          'TITULO': '部分键',
          'TOOLTIP': '写下这部分的key',
          'HINT': '没空间了',
          'ACEPTAR': '接受'
        },
        'MODALES': {
          'CONFIRM_DISABLE': '如果禁用特殊部分，当前标记为特殊部分的问题组将转换为普通问题组，此更改将适用于所有问题部分。 \n\n 确定要继续吗？',
          'DISABLE_OK': '所有找到的特殊部分都转换为正常问题组',
          'SIN_CLAVE': '要保存特殊部分，您需要输入该部分的密钥'
        }
      }
    },
  }
};
